import api from '../../utils/api'

import { useState } from 'react'
import { Navigate, useNavigate } from 'react-router-dom'



/* Hooks */
import useFlashMessage from '../../hooks/useFlashMessage'

/* form */
import FormGenerator from './Form/FormGenerator'

function NewGenerator({ btCancelAction, handleOnSuccess }) {
    const [token] = useState(localStorage.getItem('token') || '')
    const { setFlashMessage } = useFlashMessage()
    const navigate = useNavigate()

    

    async function registerGenerator(generator) {
        let msgType = 'success'

        const data = await api.post('/generator/new', generator, {
            headers: {
                Authorization: `Bearer ${JSON.parse(token)}`,
            },

        }).then((response) => {
            return response.data
        })
            .catch((err) => {
                msgType = 'error'
                return err.response.data
            })

        setFlashMessage(data.message, msgType)

        if (msgType !== 'error') {

            handleOnSuccess()
        }
    }

    return (
        <section>
            <FormGenerator title="Cadastrar Gerador" handleSubmit={registerGenerator} btCancelAction={btCancelAction} btnText="Salvar" />
        </section>
    )
}

export default NewGenerator